<template>
  <div id="handlerData">
    <Producers :data="is_admin_dealer" />
  </div>
</template>

<script>
import Vue from "vue";
import Producers from "../producer/Producers.vue"


export default {
  name: "handlerData",
  created() {
    
  },
  data() {
    return {
      is_admin_dealer:1
    };
  },
  components: {
    Producers
  },
 
  methods: {
   
  },
 
};
</script>

<style scoped>

</style>